module.exports = __webpack_public_path__ + "static/media/Logo_mateMATTIci.ea98f273.png";